<template>
  <el-row
    :gutter="5"
    style="margin: 15px 0">
    <el-col
      v-for="(item, index) in list"
      :key="index"
      :span="span"
      class="info-wrap">
      <p class="info-label">{{ item.label }}</p>
      <p :class="size === 'medium' ? 'info-value__medium' : 'info-value__small'">{{ item.value }}</p>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'SummaryList',
  props: {
    span: {
      type: Number,
      default: 6
    },
    size: {
      type: String,
      default: 'medium'
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.info-wrap {
  text-align: center;

  &+.info-wrap {
    border-left: 1px solid #c1c1c1;
  }

  .info-label {
    font-size: 15px;
  }

  .info-value__medium {
    color: #47B1FE;
    font-size: 42px;
  }

  .info-value__small {
    color: #47B1FE;
    font-size: 30px;
  }
}
</style>
